<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Comprobantes emitidos</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <span v-if="sinEmitir > 0" class="red--text text--lighten-1">Comprobantes sin emitir({{sinEmitir}})</span>
    <v-spacer></v-spacer>
    <v-btn color="primary" dark class="mb-2" @click="nuevoRegistro()">Emitir comprobante</v-btn>
  </v-toolbar>
  <v-card flat>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs1 sm1 lg1 d-flex>
            <v-text-field label="Serie" v-model="filtro.serie"></v-text-field>
          </v-flex>
          <v-flex xs2 sm2 lg2 d-flex>
            <v-text-field label="Número" mask="#######" v-model="filtro.numero"></v-text-field>
          </v-flex>
          <v-flex xs4 sm4 lg4 d-flex>
            <v-select
              :items="estadosComprobante"
              item-text="value"
              item-value="id"
              label="Estado"
              v-model="filtro.estado"
            ></v-select>
          </v-flex>
          <v-flex xs1 sm1 lg1 d-flex>
            <v-btn color="primary" dark class="mb-2" @click="listarFiltro()">Filtrar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalRegistros"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.fila[1] }}</td>
      <td class="">{{ props.item.fila[2] }}</td>
      <td class="">{{ props.item.fila[3] }}</td>
      <td class="">{{ props.item.fila[4] }}</td>
      <td class="" >
        <div v-if="(props.item.fila[5] === 'Rechazado')" style="color: red">Rechazado</div>
        <div v-if="(props.item.fila[5] === 'Sin emitir')" style="color: orange">Sin emitir</div>
        <div v-if="(props.item.fila[5] === 'Aceptado')" style="color: green">Aceptado</div>
        <div v-if="(props.item.fila[5] === 'Anulado')" style="color: blue">Anulado</div>
        </td>
      <td class="justify-center layout px-0">
        <v-icon
          small
          class="mr-2"
          @click="verRegistro(props.item)"
        >
          open_in_browser
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="imprimirRegistro(props.item)"
        >
          print
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="descargarRegistro(props.item)"
        >
          cloud_download
        </v-icon>
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">No data</v-btn>
    </template>
  </v-data-table>
  <v-dialog v-model="ventanaRegistro" max-width="90%">
    <comprobante v-on:cerrar="cerrarRegistro" v-on:listar="listar" v-bind:ubigeo="ubigeo" v-bind:idRegistro="idComprobanteActual" v-bind:idCliente="idCliente">
    </comprobante>
  </v-dialog>
</div>
</template>

<script>
import mixin from '../mixins.js'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from 'pdfmake/build/vfs_fonts.js'

export default {
  mixins: [mixin],
  name: 'comprobantes-lista',
  props: {
    ubigeo: {},
    idCliente: 0
  },
  data: () => ({
    ventanaRegistro: false,
    totalRegistros: 0,
    filtro: {serie: '', numero: '', estado: '*', reset: false},
    sinEmitir: 0,
    estadosComprobante: [{id: '*', value: '--------------------'}],
    loading: false,
    pagination: {rowsPerPage: 10},
    headers: [
      {
        text: 'Fecha',
        align: 'left',
        value: 0
      },
      { text: 'Serie', value: 1 },
      { text: 'Número', value: 2 },
      { text: 'Monto', value: 3 },
      { text: 'Estado', value: 4 },
      { text: 'Acciones', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    idComprobanteActual: ''
  }),
  watch: {
    ventanaRegistro () {
      if (this.ventanaRegistro === false) {
        this.idComprobanteActual = ''
      }
    },
    idCliente () {
      if (this.loading === false) {
        let descendente = 0
        if (this.pagination.descending) {
          descendente = 1
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
      }
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        idCliente: 0,
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        filtro: this.filtro
      }
      solicitudApi.datos = datos
      if (this.idCliente !== undefined) {
        solicitudApi.datos.idCliente = this.idCliente
      }
      const myRequest = new Request(`${process.env.NODE_API}comprobante/listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.sinEmitir = this.datos.sinEmitir
            this.totalRegistros = this.datos.registros
            for (var estadoComprobante in this.datos.estadosComprobante) {
              this.estadosComprobante.push({'id': estadoComprobante, 'value': this.datos.estadosComprobante[estadoComprobante]})
            }
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    verRegistro (item) {
      this.idComprobanteActual = item.id
      this.ventanaRegistro = true
    },
    nuevoRegistro () {
      this.idComprobanteActual = 0
      this.ventanaRegistro = true
    },
    cerrarRegistro () {
      this.ventanaRegistro = false
    },
    listarFiltro () {
      this.filtro.reset = true
      this.listar()
      this.filtro.reset = false
    },
    listar () {
      if (this.loading === false) {
        let descendente = 0
        if (this.pagination.descending) {
          descendente = 1
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
      }
    },
    imprimirRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.NODE_API}comprobante/imprimir/id/` + item.fila[0], {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(dd => {
          if (dd.content !== undefined) {
            var win = window.open('', '_blank')
            pdfMake.vfs = pdfFonts.pdfMake.vfs
            pdfMake.createPdf(dd).open({}, win)
          }
        })
    },
    descargarRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.NODE_API}comprobante/imprimir/id/` + item.fila[0], {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(dd => {
          if (dd.content !== undefined) {
            pdfMake.vfs = pdfFonts.pdfMake.vfs
            pdfMake.createPdf(dd).download(item.fila[2] + '-' + item.fila[3])
          }
        })
    }
  }
}
</script>

<style>
.v-btn--floating .v-icon {
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ComprobantesLista.vue